// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__nAnz1","selected":"Chip_selected__2_bf5"};